import { Scanner } from '@yudiel/react-qr-scanner';
import { useNavigate } from "react-router-dom";

function ShitsterScanner() {

  const navigate = useNavigate();
  const EXPRESSION = /spotify\..+\/track\/([0-9a-zA-Z.]+).*$/

  // Redirect to spotify link, when QR is scanned...
  const onScan = (data) => {
    if (!data) return
    for (const d of data) {
      const link = d.rawValue
      if (!link) continue
      const match = link.match(EXPRESSION)
      if (match) {
        navigate("/play/" + match[1])
      }
    }
  }

  return <Scanner components={{ audio: false, }} onScan={onScan} />;
}

export default ShitsterScanner
